import React, { useCallback, useState } from 'react';
import { Menu } from '@pushpay/menu';
import { clsx, createUseStyles } from '@pushpay/styles';
import { Logout } from './logout';
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  menu: ({
    deprecated
  }) => ({
    flexGrow: deprecated ? 'unset' : 1
  }),
  menuItem: {
    borderTop: `${theme.SPACING.FIELD_BORDER_WIDTH} solid ${theme.colors['palette-grey-light-300']}`,
    paddingLeft: theme.SPACING.SMALL,
    color: theme.colors['color-text-default'],
    '&:hover, &:focus': {
      textDecoration: 'none',
      color: theme.colors['color-text-default']
    },
    [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  logOut: {}
}));
export const ProfileMenu = function ProfileMenu(props) {
  const {
    classes: classesProp,
    'data-pp-at-target': targetId,
    logoutLabel,
    loggingOutLabel,
    menuItems = [],
    onLogout: onLogoutProp,
    deprecated = true
  } = props;
  const classes = useStyles(classesProp, {
    deprecated
  });
  const [isLoggingOut, setLoggingOut] = useState(false);
  const onLogout = useCallback(() => {
    setLoggingOut(true);
    onLogoutProp();
  }, [onLogoutProp]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Menu, {
    className: classes.menu,
    onItemSelected: () => {},
    selectedItem: null
  }, menuItems.map(menuItem => /*#__PURE__*/React.createElement(Menu.Item, Object.assign({
    children: null // eslint-disable-line
    ,
    className: classes.menuItem,
    key: menuItem.itemValue,
    role: "menuitem"
  }, menuItem))), /*#__PURE__*/React.createElement(Logout, {
    className: clsx(classes.menuItem, classes.logOut),
    "data-pp-at-target": `${targetId}-logout-button`,
    isLoggingOut: isLoggingOut,
    label: isLoggingOut ? loggingOutLabel : logoutLabel,
    onLogout: onLogout
  })));
};